import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { ResponseStatus } from '../../../../Response'
import { IndustryRelationResponse, MajorResponse } from '@api/gateway/Resourcetag-Default'
import IndustryRelationGateway from '@api/gateway/Resourcetag-Default'
import { IndustryAndMajor } from './module/IndustryAndMajor'

export interface IState {
  industryRelationList: Array<IndustryRelationResponse>
  industryIsLoad: boolean
}

@Module({
  namespaced: true,
  name: 'IndustryRelationModule',
  store,
  dynamic: true
})
class IndustryRelationModule extends VuexModule implements IState {
  industryRelationList = new Array<IndustryRelationResponse>()
  industryIsLoad = false
  industryAndMajorMap = new Map()

  @Action
  async loadData(): Promise<ResponseStatus> {
    if (!this.industryIsLoad) {
      const response = await IndustryRelationGateway.listIndustryRelation()
      if (response.status.isSuccess()) {
        this.SET_INDUSTRY_RELATION_LIST(response.data)
        this.SET_INDUSTRY_IS_LOAD(true)
      }
      return Promise.resolve(response.status)
    }
    return Promise.resolve(new ResponseStatus(200, ''))
  }

  @Mutation
  private SET_INDUSTRY_RELATION_LIST(data: Array<IndustryRelationResponse>) {
    this.industryRelationList = data
  }

  @Mutation
  SET_INDUSTRY_IS_LOAD(val: boolean) {
    this.industryIsLoad = val
  }

  @Mutation
  SET_INDUSTRY_AND_MAJOR_MAP() {
    this.industryAndMajorMap = new Map()
  }

  /**
   * 需在页面初始化时调用loadData
   * 指示获取行业信息
   * @returns function 参数：industryId - 行业编号
   */
  get getIndustryList() {
    return (): Array<IndustryRelationResponse> => {
      return this.industryRelationList
    }
  }

  /**
   * 需在页面初始化时调用loadData
   * 指示获取行业信息
   * @returns function 参数：industryId - 行业编号
   */
  get getIndustryInfoById() {
    return (industryId: string): IndustryRelationResponse | undefined => {
      return this.industryRelationList.find(x => x.id === industryId)
    }
  }

  /**
   * 需在页面初始化时调用loadData
   * 指示获取专业信息
   * @returns function 参数：majorId - 专业编号
   */
  get getMajorInfoById() {
    return (majorId: string): MajorResponse | undefined => {
      const majorList: Array<MajorResponse> = new Array<MajorResponse>()
      for (const industry of this.industryRelationList) {
        majorList.push(...industry.majorList)
      }
      return majorList.find(x => x.id === majorId)
    }
  }

  /**
   * 需在页面初始化时调用loadData
   * 指示获取指定行业下的专业列表
   * @returns function 参数：industryRelationId - 行业关系编号
   */
  get getMajorListByIndustryId() {
    return (industryRelationId: string): Array<MajorResponse> => {
      const currentList: Array<IndustryRelationResponse> = this.industryRelationList.filter(
        v => v.id === industryRelationId
      )
      if (currentList.length > 0) {
        return currentList[0].majorList
      }
      return []
    }
  }

  /**
   * 需在页面初始化时调用loadData
   * 查询所有专业列表
   */
  get getMajorList() {
    return (): Array<MajorResponse> => {
      const result = new Array<MajorResponse>()
      this.industryRelationList.forEach(o => {
        result.push(...o.majorList)
      })
      return result
    }
  }

  /**
   * 需在页面初始化时调用loadData
   * 根据 majorId 查询出对应的industry跟major
   * @constructor
   */
  get IndustryAndMajor() {
    return (majorId: string): IndustryAndMajor => {
      if (this.industryAndMajorMap.has(majorId)) {
        return this.industryAndMajorMap.get(majorId)
      }
      const industryAndMajor = new IndustryAndMajor()
      industryAndMajor.major = new MajorResponse()
      this.industryRelationList.filter(o => {
        o.majorList.filter(p => {
          if (p.id === majorId) {
            industryAndMajor.id = o.id
            industryAndMajor.name = o?.name || ''
            industryAndMajor.relationId = o.relationId
            industryAndMajor.major.name = p?.name || ''
            industryAndMajor.major.id = p.id
            industryAndMajor.major.relationId = p.relationId
            return true
          }
        })
      })
      this.industryAndMajorMap.set(industryAndMajor.major.id, industryAndMajor)
      return industryAndMajor
    }
  }
}

export default IndustryRelationModule
